import { createStore, combineReducers } from 'redux';
import { customerReducer } from './customerReducer';
import { loadingReducer } from './loadingReducer';
import {languageReducer} from "./languageReducer";

const rootReducer = combineReducers({
    customer: customerReducer,
    loading: loadingReducer,
    language: languageReducer
});

const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
